/* eslint-disable no-console */
import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { getNativeParams, OS_TYPES } from '@mob/mobile';
import Splash from 'components/splash/Splash';
import packageInfo from '../../../package.json';
import { parseQueryString } from '../../utils/url';
import { ENVIRONMENTS, getConfig } from '../../api/config/service';

const { version } = packageInfo;

const isNativeQueryParam = parseInt(
  get(parseQueryString(window.location.search), 'native', 0),
  10
);

export const AppConfigContext = createContext();

export function AppConfigProvider({ children, service, value }) {
  const [config, setConfig] = useState(value || {});
  useEffect(() => {
    Promise.all([service(), getNativeParams()])
      .then(([config, { data: NATIVE_PARAMS }]) => {
        const isNativeOSType = Object.keys(OS_TYPES)
          .map((type) => OS_TYPES[type])
          .includes(NATIVE_PARAMS.osType);
        const isDev = config.env === ENVIRONMENTS.DEV;
        const isProduction = config.env === ENVIRONMENTS.PRODUCTION;
        const isQA = config.env === ENVIRONMENTS.QA;
        const isNonProdNative = !!isNativeQueryParam && !isProduction;
        const isNative = isNativeOSType || isNonProdNative;
        const isWeb = !isNative;
        const { REACT_APP_BUILD_NUMBER, REACT_APP_BUILD_URL, REACT_APP_GIT_COMMIT } = process.env;

        setConfig({
          ...config,
          isDev,
          isNative,
          isProduction,
          isQA,
          isWeb,
          version,
          REACT_APP_BUILD_NUMBER,
          REACT_APP_BUILD_URL,
          REACT_APP_GIT_COMMIT
        });
      })
      // eslint-disable-next-line no-console
      .catch((e) => console.error(`failed to load the app config service: ${e}`));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (Object.keys(config).length === 0) return <Splash stage="Loading Configurations..." />;

  return (
    <AppConfigContext.Provider value={config}>
      {typeof children === 'function' ? children({ appConfig: config }) : children}
    </AppConfigContext.Provider>
  );
}

AppConfigProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  service: PropTypes.func,
  value: PropTypes.shape({})
};

AppConfigProvider.defaultProps = {
  service: getConfig,
  value: {}
};

export const useAppConfig = () => useContext(AppConfigContext);

export default AppConfigProvider;
